// Lib
import { sum } from 'lodash';

// Actions
import { createAndSelectElement, updateElement } from '../actions/elementActions';

// Selectors
import { userLanguagePreferenceSelector } from '../../user/currentUserSelector';
import { getElements } from '../selectors/elementsSelector';

// Utils
import { getNewTransactionId } from '../../utils/undoRedo/undoRedoTransactionManager';
import { convertTableElementChangesToReduxFormat } from './utils/dataUtils/persistence/tablePersistenceValueUtils';
import { TableDataVersion } from '../../../common/table/TableTypes';
import { getElement } from '../../../common/elements/utils/elementTraversalUtils';
import { getTableContentVersion, getWidth } from '../../../common/elements/utils/elementPropertyUtils';

// Constants
import { ELEMENT_UPDATE_TYPE } from '../../../common/elements/elementConstants';
import { ElementType } from '../../../common/elements/elementTypes';

export const createTable = (args) => (dispatch) => {
    const { location, content, currentBoardId, transactionId = getNewTransactionId(), creationSource } = args;

    return dispatch(
        createAndSelectElement({
            elementType: ElementType.TABLE_TYPE,
            location,
            content,
            currentBoardId,
            transactionId,
            creationSource,
        }),
    );
};

export const updateTableElement =
    ({ id, changes }) =>
    (dispatch, getState) => {
        const state = getState();
        const locale = userLanguagePreferenceSelector(state);

        const elements = getElements(state);
        const currentElement = getElement(elements, id);
        const currentTableContentVersion = getTableContentVersion(currentElement);

        const tableContentVersion = currentTableContentVersion || TableDataVersion.V2;

        const changesWithTableDataVersion =
            tableContentVersion && changes?.tableContent
                ? {
                      ...changes,
                      tableContent: {
                          ...changes.tableContent,
                          version: tableContentVersion,
                      },
                  }
                : changes;
        const changesToDispatch = convertTableElementChangesToReduxFormat(changesWithTableDataVersion, locale);

        // if there is a change to the col widths, update the table width as well
        const currentPersistedWidth = getWidth(currentElement);
        const updatedWidth = Math.round(sum(changesToDispatch.tableContent.colWidthsGU));

        const shouldUpdateWidth =
            currentPersistedWidth !== updatedWidth &&
            changesToDispatch?.tableContent?.colWidthsGU &&
            !changesToDispatch.width;

        if (shouldUpdateWidth) {
            changesToDispatch.width = updatedWidth;
        }
        dispatch(
            updateElement({
                id,
                updateType: ELEMENT_UPDATE_TYPE.TABLE,
                changes: changesToDispatch,
            }),
        );
    };
